export interface IDashCancerHistory {
    
}